import ScrollAnimation from 'react-animate-on-scroll';

function Intro() {
    return (
        <div className="align-self-center mx-3 mx-md-5 my-4 p-5 header-wrapper header-text">
            <ScrollAnimation animateIn='fadeIn' delay={1000} duration={5} animateOnce={true}>
                <div className="display-3">
                    Hello, I'm <strong>John Gilday</strong>
                </div>
                <div className="display-6">
                    An enthusiastic software developer, fueled by the thrill of creativity and collaboration,
                    with 8+ years of experience as a skilled team player, effective communicator,
                    problem solver, and lifelong learner.
                </div>
            </ScrollAnimation>
        </div>
    )

}

export default Intro;